/**
 * @author: 陈基涛
 * @date: 2022
 * @description: --
 * * 蜂助手有多个项目采用了模板化发布方案，模板化方案有助于大量参数可配置化，即使是上线了也能
 * * 根据需求随时变化
 * * 模板化方案最重要的一个点就是 window.config 字符串的提取与转化
 * * 此插件转化 window.config 并输出
 * * 注：使用此必先安装 js-base64 库
 * * 不能直接使用此库，你应该抄这个库，然后改个你喜欢的名字，比如 $windowConfig.js 放到你的项目目录!**
 */
import { Base64 } from 'js-base64'
import cutObjectEmptyProperty from './utils/cutObjectEmptyProperty.js'
import $fzs51la from './51la/fzs51la.js'

// mock
if (process?.env?.NODE_ENV === 'development') {
  window.config = ''
}

let windowConfig = {}

/**
 * 获取加密信息
 * @param str {string} 字符串
 * @return {object} 对象
 */
function parseWindowConfig (str = '') {
  if (!str) {
    return {}
  }
  let config
  try {
    let len = str.length
    config = JSON.parse(Base64.decode(str.substring(0, 10) + str.substring(11, len - 11) + str.substring(len - 10)))
  } catch (e) {
    console.error('window config parse error', e)
    config = {}
  }
  return config
}

/**
 * 重写 WindowConfig
 * @param data
 * @return {{}}
 */
function rewriteConfig (data = {}) {
  Object.assign(windowConfig, data)
  return windowConfig
}


windowConfig = {
  // 基本
  clientId: '1426',
  channelId: 'BOCGD_SBFD',
  modelId: '9',
  templateId: '14',
  testVC: '0',

  // 统计
  cnzzId: '',
  la51Id: '',

  // 支付相关
  payMethodCode: '',
  payMethodSubCode: '',

  // 接口加密相关
  appKey: '',
  appSecret: '',

  // 登录相关
  registerFrom: '',
  loginMethod: '',
  loginType: '',
  authType: 'FZS',

  // 短信相关
  extendType: '',
  instanceId: '',

  // 微信授权地址
  fzsOpenUrl: '',
  // 开通数字钱包，地址
  openDigitalWalletUrl: '',
  // 页面标题
  title: '中行数币福袋活动',
  // 首页提示
  digitalWalletDesc: '中行新老钱包客户均可预约报名，报名成功后将有机会获得无门槛数币红包盲盒，没有中行卡也能参加！报名时间：2023年1月28日至2月5日，红包有效期截至2023年2月8日。红包盲盒数量有限，先到先得。',
  // 可用商户 url
  merchantJumpUrl: '#',
  // 成功后提示
  successTip: '预约报名成功的客户将有机会在<span>3个工作日内</span>获得数字人民币红包，查看路径为：数币app-服务-消费红包.',
  //
  rule: `
    <h1>一、活动对象：</h1>
    <p>广东省内中国银行数字人民币钱包客户（深圳除外，以GPS定位为准）</p>
    <h1>二、活动时间：</h1>
    <p>2023年1月28日至2月5日 </p>
    <p>其中红包有效期截至2023年2月8日</p>
    <p>数币红包盲盒名额有限，先到先得。</p>
    <h1>三、活动内容：</h1>
    <p>1.新开通中行钱包的客户 </p>
    <p>活动期间，手机GPS定位在广东省（深圳除外）的客户通过活动页面开立中国银行数字人民币钱包，并点击“立即报名”进行预约，预约成功后将有机会在T+3个工作日内获得中行数币红包盲盒一个。 </p>
    <p>2.已开通中行钱包的客户 </p>
    <p>手机GPS定位在广东省（深圳除外）且在活动开始前已开通中行钱包的客户，在活动页面点击“立即报名”进行预约，预约成功后将有机会在T+3个工作日内获得中行数币红包盲盒一个。 </p>
    <p>红包可在指定商户使用（商户清单详见活动页面右上角-查看可用商户）。客户在指定商户消费，选择中行数字人民币钱包支付，即可直接抵扣相应金额，无门槛，放心用！ </p>
    <h1>四、活动细则：</h1>
    <ul>
    <li>1.数字人民币红包将发放至用户的数字人民币APP，客户可以下载数字人民币（试点版）APP查看红包领取情况。查询路径：数字人民币（试点版）APP-服务-消费红包-已领取。 </li>
    <li>2.红包退款规则：使用消费红包及钱包余额组合支付后发生退款或部分退款的，按照人民银行规则，先退消费红包，再退钱包余额。若退款时消费红包已过期，系统将自动回收红包。 </li>
    <li>3.本活动涉及的福利及相关服务由第三方商户提供，活动参与过程及产品使用过程中，如有疑问可联系蜂助手股份有限公司：400-1050-580转3。</li>
    <li>4.本活动由中国银行股份有限公司广东省分行提供，最终解释权在法律许可范围内归中国银行股份有限公司广东省分行所有。</li>
    </ul>
  `,



  // 微信分享设置
  appIdCode: '',
  shareTitle: '',
  shareIcon: '',
  shareDec: '',

  // 隐私政策
  agreementUrl: 'https://www.phone580.com/agreement.html',
  // 服务协议
  serviceUrl: 'https://www.phone580.com/agreement.html?code=FZSYHFWXY',
  // 登录协议
  loginProtocol: 'https://promotion.phone580.com/activity/fzs-activity-privacy-policy.html',
  // 中行隐私政策
  bocAgreementUrl: 'https://promotion.phone580.com/activity/boc-agreement/',
  // 中行跳转 url
  bocJumpUrl: '',

  // 中行，活动相关
  schemeNo: '90f085efde2b4ef6bc728f744b0c3077',
  taskId: '79200005002870',

  ruleImgUrl: '',

  // 中行领奖跳转相关
  miniProgramId: 'gh_06304860834f',  // 跳转的，小程序的原始ID gh_64f7aa756bdb(测试？)
  miniProgramPage: 'packageA/pages/ljjcompage/ljjcompage?channelId=BOCDG_GRJRHD',      // 跳转领取立减金、领取记录的小程序页面

  // 中行 bi 统计相关
  activityCode: '',
  taskIdBI: '',

  // 本次活动相关
  bannerImg: '',
  task1Img: '',
  task2Img: '',
  task3Img: '',
  posterImg: '',

  ...cutObjectEmptyProperty(parseWindowConfig(window.config))
}

// title
if (windowConfig.title) {
  window.document.title = windowConfig.title
}

// 统计
if (windowConfig.la51Id) {
  $fzs51la({
    id: windowConfig.la51Id,
    ck: windowConfig.la51Id
  })
}

if (windowConfig.testVC === '1') {
  window.vc = new window.VConsole()
}

export default windowConfig

export {
  parseWindowConfig,
  rewriteConfig,
}
